import React, { useState } from 'react';
import { AnimatedSection } from './AnimatedSection';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Necesito una computadora potente?',
  answer: 'No, todo se procesa en la nube.'
}, {
  question: '¿Sirve para cualquier nicho?',
  answer: 'Sí, desde skin-care hasta Real Estate.'
}, {
  question: '¿Es un pago único?',
  answer: 'Sí, acceso de por vida sin mensualidades.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <AnimatedSection className="px-4 py-8 md:py-14" data-id="element-22">
      <div className="max-w-3xl mx-auto" data-id="element-23">
        <h2 className="font-playfair text-2xl md:text-4xl font-bold text-center mb-10 md:mb-14" data-id="element-24">
          Preguntas <span className="text-[#d4a853]" data-id="element-25">Frecuentes</span>
        </h2>

        <div className="space-y-3" data-id="element-26">
          {faqs.map((faq, i) => <div key={i} className="border border-[#1a1a1a] bg-[#111111] rounded-sm overflow-hidden" data-id="element-27">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer" data-id="element-28">
                <span className="text-white font-medium text-sm md:text-base pr-4" data-id="element-29">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-30">
                  <ChevronDownIcon className="w-5 h-5 text-[#d4a853] flex-shrink-0" data-id="element-31" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-32">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-33">
                    <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-34">
                      <p className="text-gray-400 text-sm md:text-base" data-id="element-35">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </AnimatedSection>;
}